import dateFnsFormat from 'date-fns/format'
import dateFnsAddMinutes from 'date-fns/addMinutes'
import { formatCurrency2String } from 'src/utils/number/currency'
import { ColorScheme } from '../config'

const STYLES = {
  [ColorScheme.BRIGHT]: {
    primary: '#17181B',
    secondary: 'rgba(43, 43, 43, 0.4)',
    bground: 'rgba(0, 0, 0, 0.05)',
  },
  [ColorScheme.DARK]: {
    primary: '#fff',
    secondary: 'rgba(255, 255, 255, 0.4)',
    bground: 'rgba(255, 255, 255, 0.05)',
  },
}

const coinCss =
  'font-size:24px;line-height:28px;font-family:Roboto,sans-serif;text-transform:capitalize;'

export const getExportTitleConfig = (
  coin,
  symbol,
  change,
  price,
  scheme,
  choosenFrame
) => {
  const colors = STYLES[scheme]

  const dateColor =
    scheme == ColorScheme.BRIGHT ? '#17181B' : 'rgba(187, 188, 188, 0.5)'

  const changeColor = change >= 0 ? 'rgb(126, 193, 126)' : '#ed7171'

  let frame = '1D'
  if (choosenFrame === '5m') {
    frame = '5M'
  } else if (choosenFrame == '15m') {
    frame = '15M'
  } else if (choosenFrame == '1h') {
    frame = '1H'
  } else if (choosenFrame == '2h') {
    frame = '2H'
  }

  return {
    text: `
        <div>
          <span style="${coinCss}color:${
      colors.primary
    }">${coin} Charts</span> <span style="text-transform:none;line-height:30px;color:${dateColor};font-size:14px;font-family:Roboto,sans-serif;">
                on coin360.com, ${dateFnsFormat(
                  dateFnsAddMinutes(new Date(), new Date().getTimezoneOffset()),
                  'MMM dd, yyyy HH:mm:ss'
                )}
            </span><br/>
            <span style="${coinCss}color:${
      colors.primary
    }">${symbol}USD, <span style="${coinCss}color:${
      colors.primary
    };text-transform: capitalize">${frame}</span>, <span style="${coinCss}color:${
      colors.primary
    }">$${formatCurrency2String(
      price
    )}</span> <span style="${coinCss}color:${changeColor}"> (${
      change > 0 ? '+' + change : change
    }%)</span></span>
        </div>
        <hr color="#4A4C4B" style="margin-left:40px;margin-top: 18px;margin-right:-10px" />`,
    align: 'left',
    x: 55,
  }
}
